$(function() {
    // console.log("ready!");
    $(".fancybox").fancybox();

    $(".my-slide-wrapper").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '30px',
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });

    // $(".my-review-slide-wrapper").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     dots: false,
    //     arrows: true
    // });


    $('.tab-link').click(function() {

        var tabID = $(this).attr('data-tab');
        $(this).addClass('active').siblings().removeClass('active');
        $('#tab-' + tabID).addClass('active').siblings().removeClass('active');
    });

    if ($(".body-wrapper.template-product .multicolumn")[0]) {
        $(".body-wrapper.template-product .multicolumn .multicolumn-list").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true
        });
    }

    $("#reviews .my-review-slide-wrapper").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 7000
    });

});